import type { SlateBlock, SlateLeaf, TableBlock } from '@atlas/renderer';
import { Transforms, Element, Path, Editor } from 'slate';
import isTextBlock from '@atlas/tool/box/slate/isTextBlock';

export default function normalizeTable(editor: Editor, node: TableBlock, path: Path) {
    // TODO: @Stan normalize tables in one shot
    for (let rowIndex = node.children.length - 1; rowIndex >= 0; rowIndex--) {
        const rowNode = node.children[rowIndex];
        if (rowNode.type !== 'table-row') {
            Transforms.removeNodes(editor, { at: path.concat(rowIndex) });
        } else {
            for (let cellIndex = rowNode.children.length - 1; cellIndex >= 0; cellIndex--) {
                const cellNode = rowNode.children[cellIndex] as SlateBlock;
                if (cellNode.type === 'table-cell') {
                    for (let childIndex = cellNode.children.length - 1; childIndex >= 0; childIndex--) {
                        const childNode = cellNode.children[childIndex] as SlateBlock | SlateLeaf;
                        if (!Element.isElement(childNode)) continue;

                        if (isTextBlock(childNode)) {
                            Transforms.insertNodes(editor, childNode.children.concat({ text: '\n' }), {
                                at: path.concat(rowIndex, cellIndex, childIndex + 1),
                            });

                            Transforms.removeNodes(editor, {
                                at: path.concat(rowIndex, cellIndex, childIndex),
                            });
                        } else {
                            if (cellNode.children.length === 1) {
                                Transforms.insertText(editor, '', {
                                    at: path.concat(rowIndex, cellIndex, 1),
                                });
                            }

                            Transforms.removeNodes(editor, {
                                at: path.concat(rowIndex, cellIndex, childIndex),
                            });
                        }
                    }
                } else if (isTextBlock(cellNode)) {
                    Transforms.setNodes(
                        editor,
                        { type: 'table-cell', children: [] },
                        { at: path.concat(rowIndex, cellIndex) },
                    );
                } else {
                    Transforms.removeNodes(editor, {
                        at: path.concat(rowIndex, cellIndex),
                    });
                }
            }
        }
    }

    if (node.children.length === 0) {
        Transforms.removeNodes(editor, { at: path });
    } else {
        const columnsCount = Math.max(...node.children.map((row) => row.children.length));
        node.children.forEach((rowNode, rowIndex) => {
            if (rowNode.children.length < columnsCount) {
                const missingCells = new Array(columnsCount - rowNode.children.length).fill({
                    type: 'table-cell',
                    children: [{ type: 'paragraph', children: [{ text: '' }] }],
                });
                Transforms.insertNodes(editor, missingCells, {
                    at: path.concat(rowIndex, rowNode.children.length),
                });
            }
        });
    }
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('normalizeTable', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
